
import './App.css';
import Header from './Components/Header';
import Main from './Components/Main';
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { useState } from 'react';
function App() {

  const [user, setUser] = useState({});


  return (
    <>
      <ToastContainer position='top-left' theme='dark' />
      <Header setUser={setUser}/>
      <Main user={user}/>

    </>

  );
}

export default App;
